import { Pipe, PipeTransform, inject } from '@angular/core';

import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'month',
})
export class MonthPipe implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(value: string | number | undefined): Observable<string | undefined> {
    if (value === undefined || value === null) return of(value);
    const valueNumber = Number(value);

    return this.translateService.get(`globals.months.${valueNumber === 1 ? '1' : valueNumber > 4 ? '5' : '2-4'}`).pipe(
      switchMap((monthTranslation: string) => {
        if (typeof value === 'number') value = value.toString();
        const transformedValue = value + ' ' + monthTranslation;
        return of(transformedValue);
      }),
    );
  }
}
